/* SA&Co redesign: crossfade slideshows (.sa-fade) */
(function () {
  function start(box) {
    if (box.dataset.saStarted) return;
    box.dataset.saStarted = '1';
    var imgs = box.querySelectorAll('img');
    if (!imgs.length) return;
    imgs[0].classList.add('is-on');
    if (imgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, delay = parseInt(box.dataset.delay || '0', 10), every = parseInt(box.dataset.every || '2600', 10);
    setTimeout(function () {
      setInterval(function () {
        imgs[i].classList.remove('is-on');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-on');
      }, every);
    }, delay);
  }
  function init() { document.querySelectorAll('.sa-fade').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SA&Co redesign: place the store-wide offer box under the main product's Add to cart */
(function () {
  function placeOffer() {
    var tpl = document.getElementById('sa-offer-tpl');
    if (!tpl || document.querySelector('.sa-offer')) return;
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      return !f.closest('quick-add-drawer, .quick-add-modal, .quick-view, cart-drawer, .cart-drawer, .product-recommendations, [id*="quick"]');
    });
    var form = document.querySelector('form.product__sale-box__form') || forms.filter(function (f) { return f.querySelector('[name=add], [type=submit]') && f.offsetHeight > 0; })[0] || forms[0];
    if (!form) return;
    var box = document.createElement('div');
    box.className = 'sa';
    box.innerHTML = tpl.innerHTML;
    var offer = box.querySelector('.sa-offer');
    if (offer) offer.setAttribute('data-placed', '1');
    form.parentNode.insertBefore(box, form.nextSibling);
    var rt = document.getElementById('sa-reviews-tpl');
    var sec = form.closest('.shopify-section');
    if (rt && sec && !document.getElementById('sa-reviews') && !document.querySelector('.sa-reviews')) {
      var wrap = document.createElement('div');
      wrap.innerHTML = rt.innerHTML;
      sec.parentNode.insertBefore(wrap.firstElementChild, sec.nextSibling);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeOffer); else placeOffer();
})();

/* SA&Co redesign: product page (options, gallery, qty, details tile) */
(function () {
  function initPdp(root) {
    if (!root || root.dataset.saInit) return;
    root.dataset.saInit = '1';
    var dataEl = root.parentNode.querySelector('[data-sa-variants]') || document.querySelector('[data-sa-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = root.querySelector('[data-sa-form]');
    var input = root.querySelector('[data-variant-input]');
    var price = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var low = root.querySelector('[data-low]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var slides = root.querySelectorAll('.sa-slide');
    var info = root.querySelector('[data-info]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function show(id) {
      var found = false;
      slides.forEach(function (img) { var on = String(img.dataset.mediaId) === String(id); img.classList.toggle('is-on', on); if (on) found = true; });
      if (!found && slides[0] && id !== 'info') slides[0].classList.add('is-on');
      if (info) info.hidden = id !== 'info';
      thumbs.forEach(function (t) { t.classList.toggle('is-on', String(t.dataset.thumb) === String(id)); });
    }
    if (slides[0]) show(slides[0].dataset.mediaId);
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.thumb); }); });
    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('.sa-opt'), function (fs) {
        var b = fs.querySelector('[aria-pressed="true"]'); return b ? b.dataset.value : null;
      });
    }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return sel.every(function (s, i) { return s === null || x.options[i] === s; }); })[0];
      if (!v) { if (atc) atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable'; return; }
      input.value = v.id;
      var q = Math.max(1, parseInt(qtyInput.value || '1', 10));
      if (price) price.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart' + (q > 1 ? ' (' + q + ')' : '') + ' · ' + v.price : 'Sold out';
      if (low) low.hidden = !v.low;
      if (v.media) show(v.media);
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    root.querySelectorAll('.sa-opt').forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('.sa-pill, .sa-sw2'); if (!b) return;
        fs.querySelectorAll('.sa-pill, .sa-sw2').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var lab = fs.querySelector('[data-opt-label]'); if (lab) lab.textContent = b.dataset.label || b.dataset.value;
        update();
      });
    });
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.min(20, Math.max(1, parseInt(qtyInput.value || '1', 10) + parseInt(b.dataset.qty, 10)));
        update();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', update);
    if (variants.length) update();
  }
  function init() { document.querySelectorAll('[data-sa-product]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* SA&Co redesign: collection grid filters + sort */
(function () {
  function init() {
    var grid = document.querySelector('[data-sa-grid]');
    if (!grid) return;
    var pills = document.querySelectorAll('[data-fam]');
    var count = document.querySelector('[data-sa-count]');
    function apply(fam) {
      var n = 0;
      grid.querySelectorAll('[data-families]').forEach(function (c) {
        var on = fam === 'All' || (c.dataset.families || '').split('|').indexOf(fam) > -1;
        c.hidden = !on; if (on) n++;
      });
      pills.forEach(function (p) { p.setAttribute('aria-pressed', p.dataset.fam === fam ? 'true' : 'false'); });
      if (count) count.textContent = n + (n === 1 ? ' style' : ' styles');
    }
    pills.forEach(function (p) { p.addEventListener('click', function () { apply(p.dataset.fam); }); });
    var sort = document.querySelector('[data-sa-sort]');
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u.toString(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* SA&Co redesign: send the header bag icon to the redesigned cart page */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-drawer-trigger], .header__icon--cart, cart-drawer-toggle');
    if (!a || a.closest('.sa')) return;
    if (a.closest('header, .header, sticky-header, .shopify-section-group-header-group')) {
      e.preventDefault(); e.stopImmediatePropagation(); location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }
  }, true);
})();
